module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/15YdA0x/images/cover.jpg?1684515201160",
      "alt": "This image is the cover for the book BIOLOGY AND GENERAL SCIENCE, National Teacher Examination Series (NTE)"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("BIOLOGY AND GENERAL SCIENCE, National Teacher Examination Series (NTE)\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("The National Teacher/PRAXIS Examinations are designed to provide objective measurement of the knowledge, skills and abilities required of teachers. The Passbook® for the Biology and General Science exam provides hundreds of multiple-choice questions in the areas that will likely be covered on your upcoming certification exam, including but not limited to: basic principles of biology; anatomy and physiology; and other related areas.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      National Learning Corporation\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("National Learning Corporation has been a leading publisher of test-preparation Passbooks® for more than 50 years, with 6,000 titles available across 22 series.  The Career Examination Series features thousands of titles designed to prepare test candidates for their upcoming civil-service job exam.  Each book in the Career Series offers practice through multiple-choice questions and answers in relevant subject areas, as well as informative texts to aid in understanding the study material.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    National Learning Corporation\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 71
// module chunks = 0